module.exports = __webpack_public_path__ + "img/pic_congratulate@3x.685eaa90.png";